import React, { useState, useEffect } from "react";
import axios from "axios";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import moment from "moment";
import styles from "./UpdateMB.module.css";

const UpdateMB = () => {
    const [dateFrom, setDateFrom] = useState(
        moment().subtract(1, "day").format("YYYY-MM-DD"),
    );
    const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));

    const updateFrom = (e) => {
        const selectedDate = moment(e.target.value);
        const today = moment();

        if (selectedDate.isSameOrBefore(today, "day")) {
            setDateFrom(selectedDate.format("YYYY-MM-DD"));
        } else {
            alert("Дата от не может быть больше нынешней даты");
        }
    };

    const updateTo = (e) => {
        const selectedDate = moment(e.target.value);
        const today = moment();

        if (selectedDate.isSameOrAfter(today, "day")) {
            setDateTo(selectedDate.format("YYYY-MM-DD"));
        } else {
            alert("Дата до не может быть меньше нынешней даты");
        }
    };

    const handleUpdate = () => {
        const data = new FormData();
        data.append("date_from", dateFrom);
        data.append("date_to", dateTo);

        axios.post("/update_booking", data).then((res) => {
            if (res?.data?.result == "ok") {
                alert(res.data.text);
            } else if (res?.data?.result == "not") {
                alert("Произошла глобальная ошибка");
                console.error(res.data.text);
            } else {
                alert("Произошла ошибка");
            }
        });
    };

    return (
        <div className={styles.update_cont}>
            <TextField
                className={styles.date__field}
                label="дата от"
                type="date"
                value={dateFrom}
                onChange={updateFrom}
            />
            <TextField
                className={styles.date__field__right}
                label="дата до"
                type="date"
                value={dateTo}
                onChange={updateTo}
            />
            <Button
                className={styles.date__field__right}
                variant="contained"
                color="primary"
                onClick={handleUpdate}
            >
                Перепроверить выезды
            </Button>
        </div>
    );
};

export default UpdateMB;
